import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import type {
	ActivityListItemResponseDTO,
	TaskListItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

type DateInput = string | Date | Dayjs | null | undefined;

export const isSameOrAfter = (dateA: DateInput, dateB: DateInput): boolean => {
	if (!dateA || !dateB) return true;

	const dA = dayjs(dateA);
	const dB = dayjs(dateB);
	return dA.isSame(dB) || dA.isAfter(dB);
};

export const isSameOrBefore = (dateA: DateInput, dateB: DateInput): boolean => {
	if (!dateA || !dateB) return true;

	const dA = dayjs(dateA);
	const dB = dayjs(dateB);
	return dA.isSame(dB) || dA.isBefore(dB);
};

export function sortEventsByDateAndTitle(
	data: ActivityListItemResponseDTO[],
	t: (text: string) => string,
	type?: "asc" | "desc",
): ActivityListItemResponseDTO[];

export function sortEventsByDateAndTitle(
	data: TaskListItemResponseDTO[],
	t: (text: string) => string,
	type?: "asc" | "desc",
): TaskListItemResponseDTO[];
export function sortEventsByDateAndTitle(
	data: (ActivityListItemResponseDTO | TaskListItemResponseDTO)[],
	t: (text: string) => string,
	type: "asc" | "desc" = "asc",
) {
	return [...data].sort((a, b) => {
		if (!a || !b) return 0;

		const hasDateA = a.date != null;
		const hasDateB = b.date != null;

		const getCompositeTitle = (
			item: ActivityListItemResponseDTO | TaskListItemResponseDTO,
		) => {
			const title = item.title ?? "";
			if ("type" in item && item.type) {
				return `${t(Resources.Activity.List.ActivityType[item.type])} ${title}`;
			}
			return title;
		};

		if (!hasDateA && !hasDateB) {
			const titleCmp = getCompositeTitle(a).localeCompare(getCompositeTitle(b));
			return titleCmp;
		}

		if (!hasDateA) return 1;
		if (!hasDateB) return -1;

		const dA = dayjs(a.date);
		const dB = dayjs(b.date);

		if (dA.isBefore(dB)) return type === "asc" ? -1 : 1;
		if (dA.isAfter(dB)) return type === "asc" ? 1 : -1;

		const titleCmp = getCompositeTitle(a).localeCompare(getCompositeTitle(b));
		return titleCmp;
	});
}
